import { environment } from '../../../environments/environment';

export const appConstants = {
  months: [
    { id: '01', name: 'January', nameAr: 'يناير' },
    { id: '02', name: 'Febraury', nameAr: 'فبراير' },
    { id: '03', name: 'March', nameAr: 'مارس' },
    { id: '04', name: 'April', nameAr: 'أبريل' },
    { id: '05', name: 'May', nameAr: 'مايو' },
    { id: '06', name: 'June', nameAr: 'يونيو' },
    { id: '07', name: 'July', nameAr: 'يوليو' },
    { id: '08', name: 'August', nameAr: 'أغسطس' },
    { id: '09', name: 'September', nameAr: 'سبتمبر' },
    { id: '10', name: 'October', nameAr: 'أكتوبر' },
    { id: '11', name: 'November', nameAr: 'نوفمبر' },
    { id: '12', name: 'December', nameAr: 'ديسمبر' }
  ],
  errorCodes: {
    Forbidden: 403,
    Unauthorized: 401
  },
  portalType: 'user',
  eventCutoffTimeInMinutes: environment.eventCutoffTimeInMinutes
};
